import type { ComponentType } from "react";
import type { AnalyticsLayoutProps, ReportKind } from "../../../types";
import { AttendanceDailyAnalytics } from "./AttendanceDailyAnalytics";
import { AttendanceMonthlyAnalytics } from "./AttendanceMonthlyAnalytics";
import { LatenessAnalytics } from "./LatenessAnalytics";
import { WorkTimeAnalytics } from "./WorkTimeAnalytics";

/**
 * Davomat hisobotlarining analitik layoutlari (F bloki).
 *
 * ⚠️ Umumiy registr `components/detail/analyticsLayouts.ts` (E1) bilan
 * parallel yozilgan — integratsiyada (Z1) u yerga spread qilinadi.
 */
export const attendanceLayouts: Partial<Record<ReportKind, ComponentType<AnalyticsLayoutProps>>> = {
	// biome-ignore lint/style/useNamingConvention: ReportKind qiymati aynan shu
	attendance_daily: AttendanceDailyAnalytics,
	// biome-ignore lint/style/useNamingConvention: ReportKind qiymati aynan shu
	attendance_monthly: AttendanceMonthlyAnalytics,
	lateness: LatenessAnalytics,
	// biome-ignore lint/style/useNamingConvention: ReportKind qiymati aynan shu
	work_time: WorkTimeAnalytics,
};
